<template lang="pug">
  .page
    section
      b-container(v-if="alert.busy")
        p Confirming email...
        content-loader(:height="7", v-if="alert.loading")
      b-container(v-else-if="confirmed")
        h1 CONFIRMATION SUCCESSFUL
        h4 Your email has been confirmed
        p You may now login with your credentials
        b-button.btn-outline(:to="{name: 'login'}") LOGIN
      b-container(v-else="")
        h1 SOMETHING WENT WRONG
        h4 We were not able to confirm your email
        p Please contact support for assistance
</template>

<script>
import { userService } from '@/services';
import standardMix from '@/mixins/standardMix';

export default {
  name: 'ConfirmEmail',
  mixins: [standardMix],
  components: {
  },
  data() {
    return {
      confirmed: false,
    };
  },
  async created() {
    const token = this.$route.query.token;
    try {
      this.busy();
      await userService.confirmEmail(token);
      this.confirmed = true;
      this.clear();
    } catch (error) {
      console.log(error);
      this.error('Could not confirm email');
    }
  },
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/views/ConfirmEmail.vue